<template>

    <div v-if="! slot.exists || slot.recurrences.count > 1">
        <div v-if="! slot.exists">
            <button class="btn"
                v-if="slot.recurrences.count < 2"
                @click="openRecurrenceCountInput()"
            >Nastavit opakování</button>
            <div v-else>
                Ukončit po
                <input class="!w-16 mx-2 text-right"
                    type="number"
                    :max="maxRecurrenceCount"
                    ref="recurrenceCount"
                    v-model="slot.recurrences.count"
                    />
                opakováních,
                &nbsp;{{ recurrenceEndsOnDate.toCsDateString() }}
            </div>
        </div>
        <div v-else-if="slot.recurrences.count > 1" class="px-4 py-3 rounded-sm bg-gray-200">
            <div class="text-sm text-muted">
                Opakovaná rezervace,
                <span class="inline-block ml-2 text-xs">{{ slot.recurrences.start.toCsDateString() }} - {{ slot.recurrences.end.toCsDateString() }}</span>
            </div>
            <div class="mt-2" v-if="followingControlIsVisible">
                <label class="my-0"><input type="radio" class="form__radio bg-white" v-model="withFollowing" :value="false"> pouze toto jedno opakování</label>
                <label class="my-0"><input type="radio" class="form__radio bg-white" v-model="withFollowing" :value="true"> toto a všechna následující opakování</label>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        readonly: {
            type: Boolean,
            default: true
        },
        maxRecurrenceCount: {
            required: true
        }
    },

    data() {
        return {
            slot: this.$store.slot,
            withFollowing: false,
        }
    },

    computed: {
        followingControlIsVisible() {
            return this.slot.permissions.update
                || this.slot.permissions.delete;
        },

        recurrenceEndsOnDate() {
            return (new Date(this.slot.end))
                .addWeeks(this.slot.recurrences.count - 1);
        }
    },

    methods: {
        openRecurrenceCountInput() {
            this.slot.recurrences.count = 5;
            this.$nextTick(() => {
                this.$refs.recurrenceCount.focus();
            });
        },
    },

    watch: {
        withFollowing() {
            this.$emit('input', this.withFollowing);
        },
    },
}
</script>
